// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1WRPI","rootCenter":"LoadMoreObserver_rootCenter__1NqQ1","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__Khl__"};